<template>
  <div>
    <el-table
      v-loading="loading"
      highlight-current-row
      border
      height="500px"
      :row-class-name="tableRowClassName"
      :data="list">
      <el-table-column
        label="行业名称"
        min-width="200"
        prop="categoryName">
      </el-table-column>
      <el-table-column
        label="操作"
        width="80">
        <template slot-scope="{ row }">
          <el-link
            type="primary"
            @click="selectItem(row)">{{ row.categoryId === config.categoryId ? '已选择' : '选择' }}</el-link>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import CustomApi from '@/service/custom'
export default {
  name: 'CategoryTable',
  props: {
    config: { type: Object, default() { return { categoryId: null, categoryName: '', originalAppraisalItems: [], blandId: null, blandName: '', spuId: null, spuName: '' } } }
  },
  data() {
    return {
      loading: false,
      list: []
    }
  },
  methods: {
    tableRowClassName({ row }) {
      return row.id === this.config.categoryId ? 'current-select-row' : ''
    },
    selectItem(row) {
      const { categoryId, categoryName, originalAppraisalItems } = row
      this.$emit('update', { categoryId, categoryName, originalAppraisalItems, blandId: null, blandName: '', spuId: null, spuName: '' }, 1)
    },
    fetchList() {
      this.loading = true
      CustomApi.getappraisalcategorys({ pageNum: 1, pageSize: 100 })
        .then(res => {
          this.loading = false
          const { records, result, message } = res.data
          if ([0, -13].includes(result)) {
            this.list = records.map(i => ({
              categoryId: i.id,
              categoryName: i.categoryName,
              originalAppraisalItems: i.items.map(m => ({ ...m, enumsJson: JSON.parse(m.enumsJson), valueName: '' }))
            }))
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
